__turbopack_context__.v({
  "container": "modal-module-scss-module__8mAsLa__container",
  "overlay": "modal-module-scss-module__8mAsLa__overlay",
});
